import React from "react";

const DashSupportIcon = ({ width, height, color }) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8539 9.25L12.9569 10.17C12.2392 10.89 11.7907 11.5 11.7907 13H9.79725V12.5C9.79725 11.39 10.2458 10.39 10.9634 9.67L12.1994 8.41C12.5682 8.05 12.7874 7.55 12.7874 7C12.7874 5.89 11.8904 5 10.794 5C10.2653 5 9.75824 5.21071 9.38439 5.58579C9.01054 5.96086 8.80052 6.46957 8.80052 7H6.80705C6.80705 5.93913 7.2271 4.92172 7.9748 4.17157C8.72249 3.42143 9.73658 3 10.794 3C11.8514 3 12.8655 3.42143 13.6132 4.17157C14.3609 4.92172 14.7809 5.93913 14.7809 7C14.7809 7.88 14.4221 8.67 13.8539 9.25ZM11.7907 17H9.79725V15H11.7907V17ZM10.794 0C9.48505 0 8.18894 0.258658 6.97965 0.761205C5.77036 1.26375 4.67157 2.00035 3.74602 2.92893C1.87679 4.8043 0.82666 7.34784 0.82666 10C0.82666 12.6522 1.87679 15.1957 3.74602 17.0711C4.67157 17.9997 5.77036 18.7362 6.97965 19.2388C8.18894 19.7413 9.48505 20 10.794 20C13.4375 20 15.9727 18.9464 17.8419 17.0711C19.7112 15.1957 20.7613 12.6522 20.7613 10C20.7613 4.47 16.276 0 10.794 0Z"
        fill={color || "#828282"}
      />
    </svg>
  );
};

export default DashSupportIcon;
